import { render, staticRenderFns } from "./MailSendHistoryList.vue?vue&type=template&id=e0091d18&scoped=true&"
import script from "./MailSendHistoryList.vue?vue&type=script&lang=js&"
export * from "./MailSendHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./MailSendHistoryList.vue?vue&type=style&index=0&id=e0091d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0091d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow,VTextField})
